// "Itinerary" card of a ShareJet booking: origin + departure | flight time | destination + arrival.
import type { ReactNode } from 'react';
import { Card, Col, Descriptions, Row } from 'antd';

import type { AdminBookingDetail } from '../../api/types';
import { fmtFlightTime } from '../../data/duration';
import { withAbbr } from '../../data/airportTime';

function placeText(p: AdminBookingDetail['route']['origin']): string {
  return `${p.code} — ${p.port}, ${p.city}, ${p.country}`;
}

export function ItineraryCard({ b, extra }: { b: AdminBookingDetail; extra: ReactNode }) {
  return (
    <Card title="Itinerary" extra={extra}>
      <Row gutter={24}>
        <Col xs={24} sm={8}>
          <Descriptions column={1} bordered size="small">
            <Descriptions.Item label="Origin airport">{placeText(b.route.origin)}</Descriptions.Item>
            <Descriptions.Item label="Departure date and time">
              {/* SHAR-1192 — on the origin airport's clock, with its zone */}
              {withAbbr(`${b.departureZoned?.localDate ?? b.departureDate} ${b.departureZoned?.localTime ?? b.departureTime}`, b.departureZoned)}
            </Descriptions.Item>
          </Descriptions>
        </Col>
        <Col xs={24} sm={8}>
          <Descriptions column={1} bordered size="small">
            <Descriptions.Item label="Estimated flight time">
              {fmtFlightTime(b.estFlightTimeHours)}
            </Descriptions.Item>
          </Descriptions>
        </Col>
        <Col xs={24} sm={8}>
          <Descriptions column={1} bordered size="small">
            <Descriptions.Item label="Destination airport">{placeText(b.route.dest)}</Descriptions.Item>
            <Descriptions.Item label="Arrival date and time">
              {/* SHAR-1192 — on the DESTINATION's clock. The legacy arrivalDate/Time
                  are the origin clock plus the flight time, wrong between two zones;
                  they stay the fallback for an API without arrivalZoned. */}
              {b.arrivalZoned
                ? withAbbr(`${b.arrivalZoned.localDate} ${b.arrivalZoned.localTime}`, b.arrivalZoned)
                : b.arrivalDate
                  ? `${b.arrivalDate} ${b.arrivalTime ?? ''}`.trim()
                  : '—'}
            </Descriptions.Item>
          </Descriptions>
        </Col>
      </Row>
    </Card>
  );
}
